/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  Constellation,
  ConstellationInterface,
} from "../../../../contracts/dependant/util/Constellation";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
    ],
    name: "Erc20BalancesOfTogether",
    outputs: [
      {
        internalType: "uint256",
        name: "total",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "balances",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC721",
        name: "token",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
    ],
    name: "Erc721BalanceOfTogether",
    outputs: [
      {
        internalType: "uint256",
        name: "total",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "balances",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address payable[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "collect",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address payable[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "cover",
        type: "uint256",
      },
    ],
    name: "collectAllAndToAndTop",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address payable[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "noError",
        type: "bool",
      },
    ],
    name: "distribute",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "meta",
    outputs: [
      {
        internalType: "uint256",
        name: "blockHeight",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "blockTimestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "0x608060405234801561001057600080fd5b5061001a3361001f565b61006f565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6119788061007e6000396000f3fe6080604052600436106100865760003560e01c8063c10b983e11610059578063c10b983e14610110578063c3fd93a714610123578063c885044e14610143578063d40c54fb14610163578063f2fde38b1461017657600080fd5b8063715018a61461008b578063734e9435146100a25780638da5cb5b146100b5578063a8d0aa77146100e2575b600080fd5b34801561009757600080fd5b506100a0610196565b005b6100a06100b0366004611586565b6101aa565b3480156100c157600080fd5b506000546040516001600160a01b0390911681526020015b60405180910390f35b3480156100ee57600080fd5b506101026100fd3660046115f6565b6103c0565b6040516100d992919061164b565b6100a061011e366004611699565b610590565b34801561012f57600080fd5b5061010261013e3660046115f6565b6107bf565b34801561014f57600080fd5b5060408051438152426020820152016100d9565b6100a061017136600461173c565b610992565b34801561018257600080fd5b506100a06101913660046117ee565b611022565b61019e61109b565b6101a860006110f5565b565b6101b261109b565b6001600160a01b0385166101f75760405162461bcd60e51b81526020600482015260076024820152666572726f72212160c81b60448201526064015b60405180910390fd5b6040516370a0823160e01b81526001600160a01b038381166004830152600091908716906370a0823190602401602060405180830381865afa158015610241573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906102659190611812565b905060005b848110156103b6576000876001600160a01b03166370a082318888858181106102955761029561182b565b90506020020160208101906102aa91906117ee565b6040516001600160e01b031960e084901b1681526001600160a01b039091166004820152602401602060405180830381865afa1580156102ee573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906103129190611812565b90508060000361032257506103a4565b60008461032f8386611857565b11156103465761033f8486611870565b9050610349565b50805b61038588888581811061035e5761035e61182b565b905060200201602081019061037391906117ee565b6001600160a01b038b16908884611145565b61038f8185611857565b93508484106103a157505050506103b9565b50505b806103ae81611883565b91505061026a565b50505b5050505050565b600060608267ffffffffffffffff8111156103dd576103dd61189c565b604051908082528060200260200182016040528015610406578160200160208202803683370190505b5090506001600160a01b03851661049b5760005b838110156104955760008585838181106104365761043661182b565b905060200201602081019061044b91906117ee565b6001600160a01b03163190508083838151811061046a5761046a61182b565b602090810291909101015261047f8185611857565b935050808061048d90611883565b91505061041a565b50610588565b60005b83811015610586576000866001600160a01b03166370a082318787858181106104c9576104c961182b565b90506020020160208101906104de91906117ee565b6040516001600160e01b031960e084901b1681526001600160a01b039091166004820152602401602060405180830381865afa158015610522573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105469190611812565b90508083838151811061055b5761055b61182b565b60209081029190910101526105708185611857565b935050808061057e90611883565b91505061049e565b505b935093915050565b61059861109b565b6001600160a01b0381166105a95750335b6001600160a01b0386166105f15760405162461bcd60e51b815260206004820152600f60248201526e636f6c6c656374206572726f72212160881b60448201526064016101ee565b8184036106795760005b84811015610673576106618686838181106106185761061861182b565b905060200201602081019061062d91906117ee565b838686858181106106405761064061182b565b905060200201358a6001600160a01b0316611145909392919063ffffffff16565b8061066b81611883565b9150506105fb565b506107b7565b600082900361077e5760005b84811015610673576000876001600160a01b03166370a082318888858181106106b0576106b061182b565b90506020020160208101906106c591906117ee565b6040516001600160e01b031960e084901b1681526001600160a01b039091166004820152602401602060405180830381865afa158015610709573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061072d9190611812565b905061076b8787848181106107445761074461182b565b905060200201602081019061075991906117ee565b6001600160a01b038a16908584611145565b508061077681611883565b915050610685565b60405162461bcd60e51b815260206004820152600e60248201526d0c2dadeeadce8e65cd8cadccee8d60931b60448201526064016101ee565b505050505050565b600060608267ffffffffffffffff8111156107dc576107dc61189c565b604051908082528060200260200182016040528015610805578160200160208202803683370190505b50905060005b83811015610586576000866001600160a01b03166370a082318787858181106108365761083661182b565b905060200201602081019061084b91906117ee565b6040516001600160e01b031960e084901b1681526001600160a01b039091166004820152602401602060405180830381865afa15801561088f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906108b39190611812565b9050808383815181106108c8576108c861182b565b602002602001018181525050866001600160a01b03166370a082318787858181106108f5576108f561182b565b905060200201602081019061090a91906117ee565b6040516001600160e01b031960e084901b1681526001600160a01b039091166004820152602401602060405180830381865afa15801561094e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109729190611812565b61097c9085611857565b935050808061098a90611883565b91505061080b565b846109d05760405162461bcd60e51b815260206004820152600e60248201526d0746f2e6c656e67746820697320360941b60448201526064016101ee565b6001600160a01b038816610c6a576001600160a01b0387163314610a5c5760405162461bcd60e51b815260206004820152603960248201527f646973747269627574696e67206e617469766520746f6b656e206f6e6c79207360448201527f7570706f7274732066726f6d203d206d73672e73656e6465720000000000000060648201526084016101ee565b8015610b10578215610add5760005b85811015610ad757610ac5858583818110610a8857610a8861182b565b90506020020135888884818110610aa157610aa161182b565b9050602002016020810190610ab691906117ee565b6001600160a01b0316906111a5565b80610acf81611883565b915050610a6b565b50611018565b60005b85811015610ad757610afe83888884818110610aa157610aa161182b565b80610b0881611883565b915050610ae0565b8215610bcc5760005b85811015610ad757600080888884818110610b3657610b3661182b565b9050602002016020810190610b4b91906117ee565b6001600160a01b0316878785818110610b6657610b6661182b565b9050602002013560405160006040518083038185875af1925050503d8060008114610bad576040519150601f19603f3d011682016040523d82523d6000602084013e610bb2565b606091505b509150915050508080610bc490611883565b915050610b19565b60005b85811015610ad757600080888884818110610bec57610bec61182b565b9050602002016020810190610c0191906117ee565b6001600160a01b03168560405160006040518083038185875af1925050503d8060008114610c4b576040519150601f19603f3d011682016040523d82523d6000602084013e610c50565b606091505b509150915050508080610c6290611883565b915050610bcf565b336001600160a01b0388161480610c8b57506000546001600160a01b031633145b610d155760405162461bcd60e51b815260206004820152604f60248201527f646973747269627574696e67206572633230206f6e6c7920737570706f72747360448201527f206d73672e73656e646572203d3d2066726f6d206f72207c7c206d73672e736560648201526e6e646572203d3d206f776e6572282960881b608482015260a4016101ee565b8015610df6578215610d9c5760005b85811015610ad757610d8a88888884818110610d4257610d4261182b565b9050602002016020810190610d5791906117ee565b878785818110610d6957610d6961182b565b905060200201358c6001600160a01b0316611145909392919063ffffffff16565b80610d9481611883565b915050610d24565b60005b85811015610ad757610de488888884818110610dbd57610dbd61182b565b9050602002016020810190610dd291906117ee565b6001600160a01b038c16919086611145565b80610dee81611883565b915050610d9f565b8215610f165760005b85811015610ad757886001600160a01b03166323b872dd89898985818110610e2957610e2961182b565b9050602002016020810190610e3e91906117ee565b888886818110610e5057610e5061182b565b6040516001600160e01b031960e088901b1681526001600160a01b039586166004820152949093166024850152506020909102013560448201526064016020604051808303816000875af1925050508015610ec8575060408051601f3d908101601f19168201909252610ec5918101906118b2565b60015b610f02573d808015610ef6576040519150601f19603f3d011682016040523d82523d6000602084013e610efb565b606091505b5050610f04565b505b80610f0e81611883565b915050610dff565b60005b8581101561101657886001600160a01b03166323b872dd89898985818110610f4357610f4361182b565b9050602002016020810190610f5891906117ee565b6040516001600160e01b031960e085901b1681526001600160a01b03928316600482015291166024820152604481018690526064016020604051808303816000875af1925050508015610fc8575060408051601f3d908101601f19168201909252610fc5918101906118b2565b60015b611002573d808015610ff6576040519150601f19603f3d011682016040523d82523d6000602084013e610ffb565b606091505b5050611004565b505b8061100e81611883565b915050610f19565b505b5050505050505050565b61102a61109b565b6001600160a01b03811661108f5760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b60648201526084016101ee565b611098816110f5565b50565b6000546001600160a01b031633146101a85760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016101ee565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b604080516001600160a01b0385811660248301528416604482015260648082018490528251808303909101815260849091019091526020810180516001600160e01b03166323b872dd60e01b17905261119f9085906112c3565b50505050565b804710156111f55760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a20696e73756666696369656e742062616c616e636500000060448201526064016101ee565b6000826001600160a01b03168260405160006040518083038185875af1925050503d8060008114611242576040519150601f19603f3d011682016040523d82523d6000602084013e611247565b606091505b50509050806112be5760405162461bcd60e51b815260206004820152603a60248201527f416464726573733a20756e61626c6520746f2073656e642076616c75652c207260448201527f6563697069656e74206d6179206861766520726576657274656400000000000060648201526084016101ee565b505050565b6000611318826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b03166113959092919063ffffffff16565b8051909150156112be578080602001905181019061133691906118b2565b6112be5760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6044820152691bdd081cdd58d8d9595960b21b60648201526084016101ee565b60606113a484846000856113ac565b949350505050565b60608247101561140d5760405162461bcd60e51b815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f6044820152651c8818d85b1b60d21b60648201526084016101ee565b600080866001600160a01b0316858760405161142991906118f3565b60006040518083038185875af1925050503d8060008114611466576040519150601f19603f3d011682016040523d82523d6000602084013e61146b565b606091505b509150915061147c87838387611487565b979650505050505050565b606083156114f65782516000036114ef576001600160a01b0385163b6114ef5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e747261637400000060448201526064016101ee565b50816113a4565b6113a4838381511561150b5781518083602001fd5b8060405162461bcd60e51b81526004016101ee919061190f565b6001600160a01b038116811461109857600080fd5b60008083601f84011261154c57600080fd5b50813567ffffffffffffffff81111561156457600080fd5b6020830191508360208260051b850101111561157f57600080fd5b9250929050565b60008060008060006080868803121561159e57600080fd5b85356115a981611525565b9450602086013567ffffffffffffffff8111156115c557600080fd5b6115d18882890161153a565b90955093505060408601356115e581611525565b949793965091946060013592915050565b60008060006040848603121561160b57600080fd5b833561161681611525565b9250602084013567ffffffffffffffff81111561163257600080fd5b61163e8682870161153a565b9497909650939450505050565b6000604082018483526020604081850152818551808452606086019150828701935060005b8181101561168c57845183529383019391830191600101611670565b5090979650505050505050565b600080600080600080608087890312156116b257600080fd5b86356116bd81611525565b9550602087013567ffffffffffffffff808211156116da57600080fd5b6116e68a838b0161153a565b909750955060408901359150808211156116ff57600080fd5b5061170c89828a0161153a565b909450925050606087013561172081611525565b809150509295509295509295565b801515811461109857600080fd5b60008060008060008060008060c0898b03121561175857600080fd5b883561176381611525565b9750602089013561177381611525565b9650604089013567ffffffffffffffff8082111561179057600080fd5b61179c8c838d0161153a565b909850965060608b01359150808211156117b557600080fd5b506117c28b828c0161153a565b9095509350506080890135915060a08901356117dd8161172e565b809150509295985092959890939650565b60006020828403121561180057600080fd5b813561180b81611525565b9392505050565b60006020828403121561182457600080fd5b5051919050565b634e487b7160e01b600052603260045260246000fd5b634e487b7160e01b600052601160045260246000fd5b8082018082111561186a5761186a611841565b92915050565b8181038181111561186a5761186a611841565b60006001820161189557611895611841565b5060010190565b634e487b7160e01b600052604160045260246000fd5b6000602082840312156118c457600080fd5b815161180b8161172e565b60005b838110156118ea5781810151838201526020016118d2565b50506000910152565b600082516119058184602087016118cf565b9190910192915050565b602081526000825180602084015261192e8160408501602087016118cf565b601f01601f1916919091016040019291505056fea2646970667358221220b43640854c649ce434231e85989b0e09c6443c882f5cf96dff332576cdd7744464736f6c63430008110033";

type ConstellationConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ConstellationConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Constellation__factory extends ContractFactory {
  constructor(...args: ConstellationConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Constellation> {
    return super.deploy(overrides || {}) as Promise<Constellation>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Constellation {
    return super.attach(address) as Constellation;
  }
  override connect(signer: Signer): Constellation__factory {
    return super.connect(signer) as Constellation__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ConstellationInterface {
    return new utils.Interface(_abi) as ConstellationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Constellation {
    return new Contract(address, _abi, signerOrProvider) as Constellation;
  }
}
